import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { fileToBase64 } from '@core/utils/file-converter';
import { toImageSize } from '@core/utils/to-Image-size';
import { TranslateService } from '@ngx-translate/core';
import compress from 'browser-image-compression';
import { v4 as uuid } from 'uuid';
import { ViewQrCodeModalService } from '../../../../../core/components/view-qr-code-modal/view-qr-code-modal.service';


@Component({
  selector: 'tab-new-general',
  templateUrl: './tab-new-general.component.html',
  styleUrls: ['./tab-new-general.component.scss'],
})
export class TabNewGeneralComponent {
  @Input()
  public equipmentForm: FormGroup;

  @Input()
  public isViewMode: boolean;

  @ViewChild('pictureInput', { static: false })
  public pictureInput: ElementRef;

  constructor(
    private readonly translateService: TranslateService,
    private readonly messageService: CustomMessagesService,
    private readonly videoInfoModalService: VideoInfoModalService,
    private readonly viewQrCodeModalService: ViewQrCodeModalService
  ) {}

  public async selectPicture($event): Promise<void> {
    this.equipmentForm.get('imageUrl').setErrors(null);

    const [picture] = $event.target.files;
    const maxSize = 2 * 1024 * 1024;

    if (!picture) {
      return;
    }

    const hasInvalidType = !['image/jpg', 'image/jpeg', 'image/png'].includes(picture.type);
    const hasInvalidSize = !(picture.size && picture.size <= maxSize);

    if (hasInvalidType || hasInvalidSize) {
      const message = `EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.ERRORS.${hasInvalidType ? 'INVALID_TYPE' : 'INVALID_SIZE'}`;
      this.messageService.error(message);
      return;
    }

    const base64Picture = await fileToBase64(picture);
    const { width, height } = await toImageSize(base64Picture);

    if (width < 512 || height < 512) {
      this.messageService.error('EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.ERRORS.INVALID_DIMENSIONS');
      return;
    }

    const compressedPicture = await compress(picture, { maxSizeMB: maxSize, maxWidthOrHeight: 1920 });
    this.equipmentForm.get('imageUrl').setValue({
      thumb: base64Picture,
      file: compressedPicture,
      filename: picture.name,
      size: compressedPicture.size,
      type: picture.type
    });
  }

  public removePicture(): void {
    this.equipmentForm.get('imageUrl').setValue(null);
    this.pictureInput.nativeElement.value = '';
  }

  public async generateQrCode(): Promise<void> {
    this.equipmentForm.get('qrCode').setValue(uuid());
    this.openQrCodeDialog();
    this.messageService.success('EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.QR_CODE.SUCCESS');
  }

  public openQrCodeDialog(): void {
    this.viewQrCodeModalService.open({
      qrCode: this.equipmentForm.get('qrCode').value,
      fileName: this.equipmentForm.get('name').value
    });
  }

  public openDemonstrationVideoDialog(): void {
    this.videoInfoModalService.open({
      title: this.translateService.instant('EQUIPMENTS.DIALOG.NEW_GENERAL.FEATURE.INTRO_VIDEO.TITLE'),
      description: this.translateService.instant('EQUIPMENTS.DIALOG.NEW_GENERAL.FEATURE.INTRO_VIDEO.DESCRIPTION'),
      videoId: 'VQE_FyV8Gf0'
    });
  }
}
